export default "__VITE_ASSET__JbEMPoJj__"